// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"502":"dec4c112","773":"2a9b7fad","3165":"1f8bc7fb","5907":"45485bc4","7551":"b5178257","9214":"72a4aa0e"}[chunkId] + ".chunk.css";
};